import {
  type Answer,
  type AnswerValue,
  DataTypeQuiz,
  type Quiz,
} from '@efdigital/ll-addon-data';
import { asAsyncBelongsTo } from '@efdigital/ll-xceed-v2/data/async-setter';
import {
  findCoachingQuiz,
  queryCoachingQuizAnswer,
} from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-quiz';
import { quizAnswers } from '@efdigital/ll-xceed-v2/utils/quiz/quiz-answers';
import type { Store } from '@warp-drive/core';
import { Type } from '@warp-drive/core/types/symbols';

export type QuizAnswerPair = {
  quiz: Quiz;
  answer: Answer;
};

export async function getQuizAnswerPair(
  quizId: string,
  userId: string,
  store: Store
): Promise<QuizAnswerPair | undefined> {
  const queryQuiz = await store.request(findCoachingQuiz(quizId));
  const quiz = queryQuiz.content.data;
  if (!quiz) {
    return undefined;
  }

  const queryAnswers = await store.request(
    queryCoachingQuizAnswer(userId, quizId)
  );
  const existingAnswer = queryAnswers.content.data?.[0];
  if (existingAnswer) {
    return {
      quiz,
      answer: existingAnswer,
    };
  }

  const values: AnswerValue[] = [];
  quizAnswers(quiz.questions, values, {});

  const answer = existingAnswer
    ? existingAnswer
    : store.createRecord<Answer>(DataTypeQuiz.Answer, {
        quiz: asAsyncBelongsTo(quiz),
        modified: new Date().toISOString(),
        user: userId,
        values,
        mark: {
          [Type]: DataTypeQuiz.QuizMark,
          score: 0,
          scores: [],
          marks: [],
          totals: [],
          validation: [],
        },
        draft: true,
        consent: false,
        selections: [],
      });

  return {
    quiz,
    answer,
  };
}
